export default __webpack_public_path__ + "static/media/TERMS OF SERVICE.947cdbe8.pdf";